import { useEffect, useState, useContext } from 'react';
import { Card, Button, Row, Col, Space, Radio, Checkbox, Upload } from 'antd';
import { useNavigate } from 'react-router-dom';
import { INSTALL_TYPE, UPLOAD_STATUS } from 'constants/Constants';
import convertSchemaToConfig from '../../util/schema-to-config/SchemaToConfigGenerator';
import deploymentIcon from 'assets/images/deployment.svg';
import uploadIcon from 'assets/images/upload.svg';
import TextContent from 'resources/Text-content.json';
import ConfigMap from 'config/Config.main';
import { Context } from '../../App';
import './home.scss';

const yaml = require('js-yaml');
interface IDistributed {
    [key: string]: any
}

interface IUploadStatus {
    status: string,
    text: string
}

const Home = () => {

    const [installType, setInstallType] = useState<string | null>(null);
    const [distributed, setDistributed] = useState<IDistributed>({});
    const [uploadStatus, setUploadStatus] = useState<IUploadStatus | null>(null);
    const [fileList,setFileList] = useState<any>([]);

    const navigate = useNavigate();
    const contextValue = useContext(Context);

    const setConfigData = (data: any, installationType ?: string) => {
        contextValue.config = data;
        contextValue.installType = installationType ? installationType: installType;
        navigate('/configuration')
    }

    const generateConfiguration = (data: any) => {
        const config = convertSchemaToConfig(data);
        // console.log('config',config);
        setConfigData(config);
    }

    const handleClick = () => {
        if (installType === INSTALL_TYPE.SINGLE) {
            generateConfiguration(JSON.parse(JSON.stringify(ConfigMap)));
        } else {
            generateConfiguration(JSON.parse(JSON.stringify(distributed)));
        }
    }

    const handleChange = (checked: boolean, key: string, value: any) => {
        let newData = { ...distributed };
        if (checked) {
            newData[key] = value;
        } else {
            delete newData[key];
        }
        setDistributed(newData);
    }

    const regenerateConfiguration = (data: any) => {
        let result: any = {
            sections: {}
        };
        const config = convertSchemaToConfig(JSON.parse(JSON.stringify(ConfigMap)));
        // console.log('re config', config);
        // console.log('yaml to json data', data)
        const configSections = config?.sections;
        const dataServices = data?.services;
        Object.entries(dataServices).map((item: any) => {
            const [sectionKey, sectionValue] = item;
            const configSubsections = configSections[sectionKey]?.subsections;
            /**Add section to result */
            result.sections[sectionKey] = {
                subsections: {}
            }
            if (configSubsections) {
                Object.entries(sectionValue)?.map((subsectionItem: any) => {
                    const [subsectionKey, subsectionValue] = subsectionItem;
                    const configProps = configSubsections[subsectionKey]?.props;
                    /**Add subsection to section in result */
                    result.sections[sectionKey].subsections[subsectionKey] = {
                        props: []
                    }
                    if (configProps) {
                        let configPropResult = [...configProps];
                        Object.entries(subsectionValue)?.map((propItem: any) => {
                            const [propKey, propValue] = propItem;
                            configPropResult = configPropResult.map(val => {
                                let temp = val;
                                if (propKey === val?.name) {
                                    temp.selectedValue = propValue;
                                }
                                return temp;
                            });
                        });
                        /**Add props to subsection of the section in result */
                        result.sections[sectionKey].subsections[subsectionKey].props = configPropResult;
                    }
                });
            }
        });
        // console.log('result', result)
        setConfigData(result, data?.install_type);
    }

    const convertYamlToJson = (file: any) => {
        try {
            const jsonObj = yaml.load(file);
            regenerateConfiguration(jsonObj);
        } catch (e) {
            setUploadStatus({
                status: UPLOAD_STATUS.ERROR,
                text: TextContent?.errorConvertingYaml
            });
            console.log(e);
        }
    }

    const handleUpload = (info: any) => {
        if (info.file.status === UPLOAD_STATUS.UPLOADING) {
            setUploadStatus({
                status: UPLOAD_STATUS.UPLOADING,
                text: TextContent?.uploading
            });
        } else if (info.file.status === UPLOAD_STATUS.DONE) {
            setUploadStatus({
                status: UPLOAD_STATUS.DONE,
                text: TextContent?.upload_success
            });
            const fileType = info?.file?.name?.split(".")?.[1];
            if (fileType === "yaml" || fileType === "yml") {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    convertYamlToJson(e.target.result);
                }
                reader.readAsText(info.file.originFileObj);
            }
        } else if (info.file.status === UPLOAD_STATUS.ERROR) {
            setUploadStatus({
                status: UPLOAD_STATUS.ERROR,
                text: TextContent?.upload_error
            });
        }
        setFileList([info.file]);
    }

    const handleRemove = () => {
        setUploadStatus(null);
    }

    return (
        <div className="home-page-wrapper">
            <Card className="card">
                <Row>
                    <Col className="divider" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                        <div className="position">
                            <Space direction="vertical" size="small">
                                <img alt="Deployment" src={deploymentIcon} />
                                <br />
                                <p className="title">{TextContent?.title}</p>
                                {/* <p className="sub-title">{TextContent?.subtitle}</p> */}
                                {/* <p className="text">{TextContent?.homepage_content}</p> */}
                            </Space>
                        </div>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                        <div className="position">
                            <Space direction="vertical" size="large">
                                <div>
                                    <Space direction="vertical" size="small">
                                        <p className="selection-text">{TextContent?.uploadYaml}</p>
                                        <Upload
                                            accept=".yaml,.yml"
                                            beforeUpload={(file) => {
                                                setFileList([]);
                                                const fileType = file.name.split(".")?.[1];
                                                if (fileType === "yaml" || fileType === 'yml') {
                                                    return true
                                                } else {
                                                    setUploadStatus({
                                                        status: UPLOAD_STATUS.ERROR,
                                                        text: TextContent?.upload_fileType_error
                                                    })
                                                    return false;
                                                }
                                            }}
                                            customRequest={({ file, onSuccess }) => {
                                                setTimeout(() => {
                                                    if (onSuccess) {
                                                        onSuccess("ok");
                                                    }
                                                }, 0)
                                            }}
                                            fileList={fileList}
                                            // showUploadList={false}
                                            onChange={handleUpload}
                                            onRemove={handleRemove}
                                        >
                                            <img alt="Upload" className="img" src={uploadIcon} />
                                        </Upload>
                                        {uploadStatus ?
                                            (<p className={uploadStatus?.status === UPLOAD_STATUS.ERROR ? "uploadError" : "upload"}>
                                                {uploadStatus?.text}
                                            </p>) :
                                            null}
                                    </Space>
                                </div>
                                <div>
                                    {TextContent?.or}
                                </div>
                                <div>
                                    <Space direction="vertical" size="small">
                                        <p className="selection-text">{TextContent?.system_model}</p>
                                        <Radio.Group className="radio-group" onChange={(e) => setInstallType(e.target.value)}>
                                            <Space direction="vertical">
                                                <Radio value={INSTALL_TYPE.SINGLE}>{TextContent?.single_install}</Radio>
                                                <Radio disabled value={INSTALL_TYPE.DISTRIBUTED}>{TextContent?.distributed_install}</Radio>
                                            </Space>
                                        </Radio.Group>
                                        {installType === INSTALL_TYPE.DISTRIBUTED &&
                                            (<div>
                                                {
                                                    Object.entries(ConfigMap)?.map((item: any) => {
                                                        const [key, value] = item;
                                                        return (
                                                            <div key={key} className="checkbox-group">
                                                                <Checkbox onChange={(e) => handleChange(e.target.checked, key, value)}>{key}</Checkbox>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>)}
                                    </Space>
                                </div>
                                <Button onClick={handleClick}
                                    disabled={!(installType === INSTALL_TYPE.SINGLE || (installType === INSTALL_TYPE.DISTRIBUTED && Object.keys(distributed)?.length))}
                                    className="btn"
                                    type="primary">
                                    {TextContent?.btn_start}
                                </Button>
                            </Space>
                        </div>
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export default Home;